import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const TicketIcon = ({ height, viewBox, width, color, ...rest }) => {
    return (
        <SvgIcon width={width} height={height} viewBox={viewBox} {...rest}>
            <path
                d="M14.25 5.25V3.75C14.25 2.925 13.575 2.25 12.75 2.25H10.5C10.5 1.005 9.495 0 8.25 0C7.005 0 6 1.005 6 2.25H3.75C2.925 2.25 2.25 2.925 2.25 3.75V5.25C1.005 5.25 0 6.255 0 7.5C0 8.745 1.005 9.75 2.25 9.75V12.75C2.25 13.575 2.925 14.25 3.75 14.25H12.75C13.575 14.25 14.25 13.575 14.25 12.75V9.75C15.495 9.75 16.5 8.745 16.5 7.5C16.5 6.255 15.495 5.25 14.25 5.25ZM12.75 12.75H3.75V3.75H12.75V12.75ZM6 8.25C5.3775 8.25 4.875 7.7475 4.875 7.125C4.875 6.5025 5.3775 6 6 6C6.6225 6 7.125 6.5025 7.125 7.125C7.125 7.7475 6.6225 8.25 6 8.25ZM11.625 7.125C11.625 7.7475 11.1225 8.25 10.5 8.25C9.8775 8.25 9.375 7.7475 9.375 7.125C9.375 6.5025 9.8775 6 10.5 6C11.1225 6 11.625 6.5025 11.625 7.125ZM5.25 9.75H11.25V11.25H5.25V9.75Z"
                fill={color}
            />
        </SvgIcon>
    );
};

TicketIcon.propTypes = {
    height: string,
    viewBox: string,
    width: string,
    color: string,
};

TicketIcon.defaultProps = {
    height: '15',
    viewBox: '0 0 17 15',
    width: '17',
    color: `${MIGRATED_COLORS.orange}`,
};

export default TicketIcon;
